import { AllSameKeyValuesEnforcer } from './helpers'
import { TableText, TableLights, TableLightsWithURLForExport, TableUpdatedText, TableDate, TableLabel, TableUrl, TableImage, TableSocial, TableEmail, TableRank, TableUser, TableHHMM, TableIconText, TableAccount, TableCheck, TableFlag, TableComments, TableFiles, TableEntity, TableStars, TableTaskStatus } from './table.data'
import { PublishInfo, ShareOSSInfo, SessionItemInfo, LogisticsShareable } from '../../../globals/store/share.data'
import { Performer } from '../../../globals/store/performers.data'
import { WFWorker } from '"./../../globals/store/workforce.data'
import { Sponsor } from 'globals/store/sponsors.data';
import { SessionInfo } from '"./../../globals/store/programs.data'
import { LogEntry, Task } from '../../../globals/store/tasks.data'
import { Exhibitor, ExhibitorStand } from '../../../globals/store/exhibitors.data';
import { Entity } from '"./../../globals/store/entity.data'
import { Asset } from '../../../globals/store/assets.data';
import { JoiResource } from '../../../globals/store/resources.data';
import { Program } from '"./../../globals/store/programs.data'
import { JoiAppInfo } from '"./../../globals/store/app.data'
import { Attendee } from '../../../globals/store/attendees.data'
import { EventListInfo } from 'globals/store/share.event-lists.data'

export interface BaseTableData {
  id: string
  dimmed?: boolean
  seen?: 'seen' | 'unseen'
  nestedIds?: string[]
  noNestedText?: string
  activeDotMenuOptions?: Set<string>
}

interface TemplateTableColumnIds { WFEmail, eventName, createdDate, modifiedDate, entity, stars }
export const templateTableColumns: AllSameKeyValuesEnforcer<TemplateTableColumnIds> = { WFEmail: 'WFEmail', eventName: 'eventName', createdDate: 'createdDate', modifiedDate: 'modifiedDate', entity: 'entity', stars: 'stars' }
export interface BaseTemplateTableData extends BaseTableData {
  [templateTableColumns.entity]: Entity
  [templateTableColumns.WFEmail]: TableText // only shows on template because can't reasonably create WFWorker from just the email
  [templateTableColumns.eventName]: TableText
  [templateTableColumns.modifiedDate]: TableDate
  [templateTableColumns.createdDate]: TableDate
  [templateTableColumns.stars]: TableStars
}


interface PerformerTableColumnIds { name, performer, contact, contactName, status, confirmed, briefed, sessionAssets,
  publicEditProfileStatus, sessions, phone, line1, line2, logo, bio, labels, email, photo,
  sessionsAccepted, assets, social, terms, briefUrl, briefActions, hideInPublish, address, performerType, stars, }

export const performerTableColumns: AllSameKeyValuesEnforcer<PerformerTableColumnIds> = { name: 'name', performer: 'performer', contact: 'contact', contactName: 'contactName', status: 'status', confirmed: 'confirmed', briefed: 'briefed', publicEditProfileStatus: 'publicEditProfileStatus', sessions: 'sessions', phone: 'phone', line1: 'line1', line2: 'line2', logo: 'logo', bio: 'bio', labels: 'labels', email: 'email', sessionsAccepted: 'sessionsAccepted', assets: 'assets', social: 'social', terms: 'terms', briefUrl: 'briefUrl', briefActions: 'briefActions', hideInPublish: 'hideInPublish', address: 'address', performerType: 'performerType', photo: 'photo', stars: 'stars', sessionAssets: 'sessionAssets' }

export const excludedPerformerClipboardColumns: Array<keyof PerformerTableColumnIds> = ['assets', 'status', 'confirmed', 'briefed', 'publicEditProfileStatus', 'contact', 'sessions', 'labels', 'briefUrl', 'briefActions', 'terms', 'hideInPublish', 'sessionAssets']

export interface PerformerBaseTableData extends BaseTemplateTableData {
  [performerTableColumns.performer]: Performer
  [performerTableColumns.name]: TableUser
  [performerTableColumns.address]: TableText
  [performerTableColumns.phone]: TableText
  [performerTableColumns.line1]: TableText
  [performerTableColumns.line2]: TableText
  [performerTableColumns.social]: TableSocial[]
  [performerTableColumns.bio]: TableText
  [performerTableColumns.contactName]: TableText
  [performerTableColumns.email]: TableEmail
  [performerTableColumns.logo]: TableImage
  [performerTableColumns.photo]: TableImage
}

export interface PerformerTableData extends PerformerBaseTableData {
  [performerTableColumns.assets]: TableLights
  [performerTableColumns.sessionAssets]: TableLights
  [performerTableColumns.briefed]: TableLights
  [performerTableColumns.contact]: WFWorker
  [performerTableColumns.status]: TableLights
  [performerTableColumns.sessions]: TableText
  [performerTableColumns.publicEditProfileStatus]: TableLightsWithURLForExport
  [performerTableColumns.confirmed]: TableLights
  [performerTableColumns.terms]: TableLights
  [performerTableColumns.briefUrl]: TableLightsWithURLForExport
  [performerTableColumns.briefActions]: TableLights
  [performerTableColumns.labels]: TableLabel[]
  [performerTableColumns.performerType]: TableRank
  [performerTableColumns.hideInPublish]: TableLights
}

interface AttendeeTableColumnIds { name, attendee, contact, status, 
  publicEditProfileStatus, sessions, phone, line1, line2, labels, email, photo, address
social, briefUrl, briefActions, attendeeType, terms, contactEmail }

export const attendeeTableColumns: AllSameKeyValuesEnforcer<AttendeeTableColumnIds> = { name: 'name', attendee: 'attendee', contact: 'contact', status: 'status', publicEditProfileStatus: 'publicEditProfileStatus', sessions: 'sessions', phone: 'phone', line1: 'line1', line2: 'line2', labels: 'labels', email: 'email', social: 'social', briefUrl: 'briefUrl', briefActions: 'briefActions', address: 'address', attendeeType: 'attendeeType', photo: 'photo', terms: 'terms', contactEmail: 'contactEmail' }

export const excludedAttendeeClipboardColumns: Array<keyof AttendeeTableColumnIds> = ['status', 'publicEditProfileStatus', 'contact', 'sessions', 'labels', 'briefUrl', 'briefActions', 'terms', 'attendeeType']

export interface AttendeeBaseTableData extends BaseTemplateTableData {
  [attendeeTableColumns.attendee]: Attendee
  [attendeeTableColumns.name]: TableUser
  [attendeeTableColumns.address]: TableText
  [attendeeTableColumns.phone]: TableText
  [attendeeTableColumns.line1]: TableText
  [attendeeTableColumns.line2]: TableText
  [attendeeTableColumns.social]: TableSocial[]
  [attendeeTableColumns.email]: TableEmail
  [attendeeTableColumns.photo]: TableImage
}

export interface AttendeeTableData extends AttendeeBaseTableData {
  [attendeeTableColumns.contact]: WFWorker
  [attendeeTableColumns.status]: TableLights
  [attendeeTableColumns.sessions]: TableText
  [attendeeTableColumns.publicEditProfileStatus]: TableLightsWithURLForExport
  [attendeeTableColumns.briefUrl]: TableLightsWithURLForExport
  [attendeeTableColumns.briefActions]: TableLights
  [attendeeTableColumns.labels]: TableLabel[]
  [attendeeTableColumns.terms]: TableLights
  [attendeeTableColumns.attendeeType]: TableRank
}

interface CustomAnswerColumnIds { entityName, entityType, stars }
export const customAnswerColumns: AllSameKeyValuesEnforcer<CustomAnswerColumnIds> = {
  entityName: 'entityName', entityType: 'entityType', stars: 'stars'
}
export interface CustomAnswerColumnData extends BaseTableData {
  [customAnswerColumns.entityName]: TableText
  [customAnswerColumns.entityType]: TableText
  [customAnswerColumns.stars]: TableStars
  [key: string]: any // Force this to work
}

interface SurveyResponseColumnIds { name, email }
export const surveyResponseColumns: AllSameKeyValuesEnforcer<SurveyResponseColumnIds> = {
  name: 'name', email: 'email'
}
export interface SurveyResponseColumnData extends BaseTableData {
  [surveyResponseColumns.name]: TableText
  [surveyResponseColumns.email]: TableEmail
  [key: string]: any // Force this to work
}

interface ExhibitorColumnIds { name, detailsConfirmed, confirmed, standSize, standNumber, callToActionText, callToActionUrl, logo, social, contactName, contactEmail, contactNumber, editingUrlStatus, program, labels, description, workforceContact, standNotes, briefUrl, briefActions, terms, hideInPublish, stands, assets, address, exhibitorType, stars, standAssets }

export const exhibitorColumns: AllSameKeyValuesEnforcer<ExhibitorColumnIds> = { name: 'name', detailsConfirmed: 'detailsConfirmed', confirmed: 'confirmed', standNumber: 'standNumber', standSize: 'standSize', callToActionText: 'callToActionText', callToActionUrl: 'callToActionUrl', logo: 'logo', social: 'social', contactName: 'contactName', contactEmail: 'contactEmail', contactNumber: 'contactNumber', editingUrlStatus: 'editingUrlStatus', program: 'program', labels:'labels', description: 'description', workforceContact: 'workforceContact', standNotes: 'standNotes', briefUrl: 'briefUrl', briefActions: 'briefActions', terms: 'terms', hideInPublish: 'hideInPublish', stands: 'stands', assets: 'assets', address: 'address', exhibitorType: 'exhibitorType', stars: 'stars', standAssets: 'standAssets' }

export const excludedExhibitorClipboardColumns: Array<keyof ExhibitorColumnIds> = ['confirmed', 'standSize', 'standNumber', 'standNotes', 'detailsConfirmed', 'editingUrlStatus', 'program', 'labels', 'briefUrl', 'briefActions', 'terms', 'hideInPublish', 'workforceContact', 'stands', 'exhibitorType', 'standAssets' ]
export interface ExhibitorsBaseTableData extends BaseTemplateTableData {
  exhibitor: Exhibitor
  [exhibitorColumns.name]: TableText
  [exhibitorColumns.description]: TableText
  [exhibitorColumns.address]: TableText
  [exhibitorColumns.callToActionText]: TableText
  [exhibitorColumns.callToActionUrl]: TableUrl
  [exhibitorColumns.logo]: TableImage
  [exhibitorColumns.social]: TableSocial[]
  [exhibitorColumns.contactName]: TableText
  [exhibitorColumns.contactEmail]: TableEmail
  [exhibitorColumns.contactNumber]: TableText
}

export interface ExhibitorsTableData extends ExhibitorsBaseTableData {
  [exhibitorColumns.program]: TableText
  [exhibitorColumns.assets]: TableLights
  [exhibitorColumns.standAssets]: TableLights
  [exhibitorColumns.detailsConfirmed]: TableLights
  [exhibitorColumns.confirmed]: TableLights
  [exhibitorColumns.editingUrlStatus]: TableLightsWithURLForExport
  [exhibitorColumns.briefUrl]: TableLightsWithURLForExport
  [exhibitorColumns.briefActions]: TableLights
  [exhibitorColumns.terms]: TableLights
  [exhibitorColumns.hideInPublish]: TableLights
  [exhibitorColumns.stands]: TableText
  [exhibitorColumns.labels]: TableLabel[]
  [exhibitorColumns.workforceContact]: WFWorker
  [exhibitorColumns.exhibitorType]: TableRank
}

interface SponsorsColumnIds { name, detailsConfirmed, editingUrlStatus, sessionSummary, description, callToActionText, callToActionUrl, logo, social, contactName, contactEmail, contactNumber, sponsorType, labels, workforceContact, sessionCount, sponsorStatus, hideInPublish, address, stars, assets, sessionAssets }

export const sponsorColumns: AllSameKeyValuesEnforcer<SponsorsColumnIds> = { name: 'name', detailsConfirmed: 'detailsConfirmed', description: 'description', editingUrlStatus: 'editingUrlStatus', sessionCount: 'sessionCount', sessionSummary: 'sessionSummary', callToActionText: 'callToActionText', callToActionUrl: 'callToActionUrl', logo: 'logo', social: 'social', contactEmail: 'contactEmail', contactName: 'contactName', contactNumber: 'contactNumber', sponsorType: 'sponsorType', labels: 'labels', workforceContact: 'workforceContact', sponsorStatus: 'sponsorStatus', hideInPublish: 'hideInPublish', address: 'address', stars: 'stars', assets: 'assets', sessionAssets: 'sessionAssets' }

export const excludedSponsorClipboardColumns: Array<keyof SponsorsColumnIds> = ['detailsConfirmed', 'editingUrlStatus', 'labels', 'hideInPublish', 'workforceContact', 'sponsorStatus', 'sponsorType', 'sessionSummary', 'sessionCount', 'assets', 'sessionAssets' ]

export interface SponsorsBaseTableData extends BaseTemplateTableData {
  sponsor: Sponsor
  [sponsorColumns.name]: TableText
  [sponsorColumns.description]: TableText
  [sponsorColumns.address]: TableText
  [sponsorColumns.callToActionText]: TableText
  [sponsorColumns.callToActionUrl]: TableUrl
  [sponsorColumns.logo]: TableImage
  [sponsorColumns.social]: TableSocial[]
  [sponsorColumns.contactName]: TableText
  [sponsorColumns.contactEmail]: TableEmail
  [sponsorColumns.contactNumber]: TableText
}


export interface SponsorsTableData extends SponsorsBaseTableData {
  [sponsorColumns.detailsConfirmed]: TableLights
  [sponsorColumns.editingUrlStatus]: TableLightsWithURLForExport
  [sponsorColumns.sessionSummary]: TableLights
  [sponsorColumns.sponsorType]: TableRank
  [sponsorColumns.sponsorStatus]: { [sponsorId: string]: TableLights }
  [sponsorColumns.labels]: TableLabel[]
  [sponsorColumns.workforceContact]: WFWorker
  [sponsorColumns.sessionCount]: TableText
  [sponsorColumns.hideInPublish]: TableLights
  [sponsorColumns.assets]: TableLights
  [sponsorColumns.sessionAssets]: TableLights
}

interface ResourcesColumnIds { name, detailsConfirmed, editingUrlStatus, description, logo, social, contactName, contactEmail, contactNumber, labels, workforceContact, assets, files, resourceType, terms, stars }

export const resourceColumns: AllSameKeyValuesEnforcer<ResourcesColumnIds> = { name: 'name', detailsConfirmed: 'detailsConfirmed', description: 'description', editingUrlStatus: 'editingUrlStatus', logo: 'logo', social: 'social', contactEmail: 'contactEmail', contactName: 'contactName', contactNumber: 'contactNumber', labels: 'labels', workforceContact: 'workforceContact', assets: 'assets', files: 'files', resourceType: 'resourceType', terms: 'terms', stars: 'stars' }

export const excludedResourceClipboardColumns: Array<keyof ResourcesColumnIds> = ['detailsConfirmed', 'editingUrlStatus', 'labels', 'assets', 'workforceContact', 'files', 'resourceType', 'terms' ]

export interface ResourcesBaseTableData extends BaseTemplateTableData {
  resource: JoiResource
  [resourceColumns.name]: TableText
  [resourceColumns.description]: TableText
  [resourceColumns.logo]: TableImage
  [resourceColumns.social]: TableSocial[]
  [resourceColumns.contactName]: TableText
  [resourceColumns.contactEmail]: TableEmail
  [resourceColumns.contactNumber]: TableText
}

export interface ResourcesTableData extends ResourcesBaseTableData {
  [resourceColumns.detailsConfirmed]: TableLights
  [resourceColumns.editingUrlStatus]: TableLightsWithURLForExport
  [resourceColumns.labels]: TableLabel[]
  [resourceColumns.workforceContact]: WFWorker
  [resourceColumns.assets]: TableLights
  [resourceColumns.files]: TableText
  [resourceColumns.resourceType]: TableRank
  [resourceColumns.terms]: TableLights
}

interface QuoteColumnIds { resource, name, link, notes, type, quoteStatus, status, url, deadline, submitted, total, discountAmount, discountPercent, workforceContact, eventName }

export const quoteColumns: AllSameKeyValuesEnforcer<QuoteColumnIds> = { resource: 'resource', name: 'name', link: 'link', 
  notes: 'notes', type: 'type', status: 'status', url: 'url', deadline: 'deadline', submitted: 'submitted', 
  total: 'total', discountAmount: 'discountAmount', discountPercent: 'discountPercent', workforceContact: 'workforceContact', 
  eventName: 'eventName', quoteStatus: 'quoteStatus' }

export interface QuoteTableData extends BaseTableData {
  quoteId: string
  resourceId: string
  [quoteColumns.resource]: TableText
  [quoteColumns.eventName]: TableText
  [quoteColumns.name]: TableText
  [quoteColumns.link]: TableUrl
  [quoteColumns.url]: TableUrl
  [quoteColumns.notes]: TableText
  [quoteColumns.type]: TableText
  [quoteColumns.quoteStatus]: TableLights
  [quoteColumns.status]: TableLights
  [quoteColumns.deadline]: TableDate
  [quoteColumns.submitted]: TableDate
  [quoteColumns.total]: TableText
  [quoteColumns.discountAmount]: TableText
  [quoteColumns.discountPercent]: TableText
  [quoteColumns.workforceContact]: WFWorker
}


interface BudgetColumnIds { eventName, startDate, eventStatus, revenue, costs, profit, profitPercent, currency, taxType }

export const budgetColumns: AllSameKeyValuesEnforcer<BudgetColumnIds> = { eventName: 'eventName', startDate: 'startDate', eventStatus: 'eventStatus', revenue: 'revenue', costs: 'costs', profit: 'profit', profitPercent: 'profitPercent', currency: 'currency', taxType: 'taxType' }

export interface BudgetTableData extends BaseTableData {
  [budgetColumns.eventName]: TableText
  [budgetColumns.startDate]: TableDate
  [budgetColumns.eventStatus]: TableText
  [budgetColumns.revenue]: TableText
  [budgetColumns.currency]: TableText
  [budgetColumns.taxType]: TableText
  [budgetColumns.costs]: TableText
  [budgetColumns.profit]: TableText
  [budgetColumns.profitPercent]: TableText
}

interface TaskTimeTableColumnIds { name, responsibility, visibility, estimatedTime, loggedTime, difference }
export const taskTimeColumns: AllSameKeyValuesEnforcer<TaskTimeTableColumnIds> = { name: 'name', responsibility: 'responsibility', visibility: 'visibility', estimatedTime: 'estimatedTime', loggedTime: 'loggedTime', difference: 'difference' }

export interface TaskTimeTableData extends BaseTableData {
  task: Task,
  [taskTimeColumns.name]: TableText,
  [taskTimeColumns.responsibility]: TableUser,
  [taskTimeColumns.visibility]: TableIconText,
  [taskTimeColumns.estimatedTime]: TableHHMM,
  [taskTimeColumns.loggedTime]: TableHHMM,
  [taskTimeColumns.difference]: TableHHMM,
}

interface TimeLogColumnIds { task, loggedTime, notes, loggedBy, date }
export const timeLogColumns: AllSameKeyValuesEnforcer<TimeLogColumnIds> = { task: 'task', loggedBy: 'loggedBy', loggedTime: 'loggedTime', notes: 'notes', date: 'date' }
export interface TimeLogData extends BaseTableData {
  timeLog: LogEntry,
  fullTask: Task,
  [timeLogColumns.task]?: TableText
  [timeLogColumns.loggedTime]: TableHHMM
  [timeLogColumns.loggedBy]: TableUser
  [timeLogColumns.date]: TableDate
  [timeLogColumns.notes]: TableText
}

export interface AssetColumnIds { ready, flagged, responsibility, dueBy, labels, creator, description, name, assetURL, editingURL, used, tasks, icon, linked, associatedWith, attachedTo, quantity, category }
export const assetColumns: AllSameKeyValuesEnforcer<AssetColumnIds> = { ready: 'ready', flagged: 'flagged', responsibility: 'responsibility', dueBy: 'dueBy',
  labels: 'labels', creator: 'creator', description: 'description', name: 'name', assetURL: 'assetURL', editingURL: 'editingURL', 
  used: 'used', tasks: 'tasks', icon: 'icon', linked: 'linked', associatedWith: 'associatedWith', attachedTo: 'attachedTo', quantity: 'quantity', category: 'category' }
export const excludedAssetClipboardColumns: Array<keyof AssetColumnIds> = [ 'labels', 'ready', 'flagged', 'responsibility', 'dueBy', 'creator', 'editingURL', 'used', 'tasks', 'linked', 'associatedWith', 'attachedTo', 'quantity', 'category' ]

export interface AssetsBaseTableData extends BaseTemplateTableData {
  asset: Asset
  [assetColumns.name]: TableText
  [assetColumns.description]: TableText
  [assetColumns.icon]: TableIconText
  [assetColumns.assetURL]: TableUrl
}
export interface AssetTableData extends AssetsBaseTableData {

  [assetColumns.flagged]: TableFlag
  [assetColumns.responsibility]: TableUser 
  [assetColumns.dueBy]: TableDate
  [assetColumns.category]: TableText
  [assetColumns.quantity]: TableText
  [assetColumns.editingURL]: TableUrl 
  [assetColumns.creator]: TableUser
  [assetColumns.associatedWith]: TableEntity
  [assetColumns.used]: TableText 
  [assetColumns.ready]: TableLights 
  [assetColumns.tasks]: TableLights
  [assetColumns.labels]: TableLabel[]
  [assetColumns.linked]: TableText
  [assetColumns.attachedTo]: TableText
  
}


interface BaseTaskColumnIds { flagged, commented, task, responsibility, dueBy, additionalInfo, subTasks, visibility, program, labels, files, creator, status, associatedWith }
export interface ExtraTaskColumnIds { event, account }
export interface AllTaskColumnIds extends BaseTaskColumnIds, ExtraTaskColumnIds {}
export const taskTableColumns: AllSameKeyValuesEnforcer<AllTaskColumnIds> = { flagged: 'flagged', commented: 'commented', task: 'task', responsibility: 'responsibility', dueBy: 'dueBy', additionalInfo: 'additionalInfo', subTasks: 'subTasks', visibility: 'visibility', program: 'program', labels: 'labels', files: 'files', creator: 'creator', event: 'event', account: 'account', status: 'status', associatedWith: 'associatedWith' }

export interface TaskTableData extends BaseTableData {
  eventId: string
  fullTask: Task
  readOnly: boolean
  [taskTableColumns.flagged]: TableFlag
  [taskTableColumns.commented]: TableComments 
  [taskTableColumns.task]: TableText 
  [taskTableColumns.associatedWith]: TableText
  [taskTableColumns.responsibility]: TableUser 
  [taskTableColumns.dueBy]: TableDate
  [taskTableColumns.additionalInfo]: TableText
  [taskTableColumns.subTasks]: TableLights
  [taskTableColumns.visibility]: TableIconText
  [taskTableColumns.program]: TableText 
  [taskTableColumns.labels]: TableLabel[]
  [taskTableColumns.files]: TableFiles
  [taskTableColumns.creator]: TableUser
  [taskTableColumns.event]: TableText
  [taskTableColumns.account]: TableAccount
  [taskTableColumns.status]: TableTaskStatus
}


interface EventListTableColumnIds { name, status, updated, eventListInfo, account, description, created }
export const eventListTableColumns: AllSameKeyValuesEnforcer<EventListTableColumnIds> = { eventListInfo: 'eventListInfo', name: 'name', status: 'status', updated: 'updated', description: 'description', account: 'account', created: 'created' }
export interface EventListTableData extends BaseTableData {
  [eventListTableColumns.name]: TableText
  [eventListTableColumns.description]: TableText
  [eventListTableColumns.status]: TableLights
  [eventListTableColumns.created]: TableUpdatedText
  [eventListTableColumns.updated]: TableUpdatedText
  [eventListTableColumns.account]: TableAccount
  [eventListTableColumns.eventListInfo]: EventListInfo
}

interface PublishTableColumnIds { name, status, updated, publishInfo, description, eventLists }
export const publishTableColumns: AllSameKeyValuesEnforcer<PublishTableColumnIds> = { publishInfo: 'publishInfo', name: 'name', status: 'status', updated: 'updated', description: 'description', eventLists: 'eventLists' }
export interface PublishTableData extends BaseTableData {
  [publishTableColumns.name]: TableText
  [publishTableColumns.description]: TableText
  [publishTableColumns.status]: TableLights
  [publishTableColumns.updated]: TableUpdatedText
  [publishTableColumns.publishInfo]: PublishInfo
  [publishTableColumns.eventLists]: TableLights
}

interface ShareTableColumnIds { name, status, shareInfo, description }
export const shareTableColumns: AllSameKeyValuesEnforcer<ShareTableColumnIds> = { name: 'name', status: 'status', shareInfo: 'shareInfo', description: 'description' }
export interface ShareTableData extends BaseTableData {
  [shareTableColumns.name]: TableText
  [shareTableColumns.description]: TableText
  [shareTableColumns.status]: TableLights
  [shareTableColumns.shareInfo]: ShareOSSInfo
}

export interface LogisticsShareTableData extends BaseTableData {
  [shareTableColumns.name]: TableText
  [shareTableColumns.description]: TableText
  [shareTableColumns.status]: TableLights
  [shareTableColumns.shareInfo]: LogisticsShareable
}

interface AppTableColumnIds { app, name, description, status, updated, created }
export const appTableColumns: AllSameKeyValuesEnforcer<AppTableColumnIds> = { app: 'app', name: 'name', status: 'status', description: 'description', updated: 'updated', created: 'created' }

export interface AppTableData extends BaseTableData {
  [appTableColumns.app]: JoiAppInfo
  [appTableColumns.name]: TableText
  [appTableColumns.description]: TableText
  [appTableColumns.status]: TableLights
  [appTableColumns.created]: TableUpdatedText
  [appTableColumns.updated]: TableUpdatedText
}


interface BriefTableColumnIds { name, sessions, briefStatus, briefUrl, terms, assetInfo, performer, exhibitor, status }
export const briefTableColumns: AllSameKeyValuesEnforcer<BriefTableColumnIds> = { name: 'name', sessions: 'sessions', briefStatus: 'briefStatus', briefUrl: 'briefUrl', terms: 'terms', assetInfo: 'assetInfo', performer: 'performer', exhibitor: 'exhibitor', status: 'status' }

export interface PerformerBriefTableData extends BaseTableData {
  [briefTableColumns.performer]: Performer
  [briefTableColumns.name]: TableText
  [briefTableColumns.sessions]: TableText
  [briefTableColumns.briefStatus]: TableLights
  [briefTableColumns.briefUrl]: TableLightsWithURLForExport
  [briefTableColumns.terms]: TableLights
  [briefTableColumns.assetInfo]: SessionItemInfo[]
}

export interface ExhibitorBriefTableData extends BaseTableData {
  [briefTableColumns.exhibitor]: Exhibitor
  [briefTableColumns.name]: TableText
  [briefTableColumns.status]: TableLights
  [briefTableColumns.briefUrl]: TableLightsWithURLForExport
}


interface SessionTableColumnIds { name, summary, briefed, sessionInfo, confirmed, dateTime, description, performers, sessionLabels, programName, programLabels, performerStatus, assets, stagingRequests, sessionUrl, sponsors, stagingNotes, publicLinks, briefNotes, flagged, performerAssets, sponsorAssets, showInPublish, duration, attendees }
export const sessionColumns: AllSameKeyValuesEnforcer<SessionTableColumnIds> = { name: 'name', summary: 'summary', briefed: 'briefed', confirmed: 'confirmed', dateTime: 'dateTime', description: 'description', performers: 'performers', sessionLabels: 'sessionLabels', programName: 'programName', programLabels: 'programLabels', performerStatus: 'performerStatus', sessionInfo: 'sessionInfo', assets: 'assets', stagingRequests: 'stagingRequests', sessionUrl: 'sessionUrl', sponsors: 'sponsors', stagingNotes: 'stagingNotes', briefNotes: 'briefNotes', publicLinks: 'publicLinks', flagged: 'flagged', performerAssets: 'performerAssets', sponsorAssets: 'sponsorAssets', showInPublish: 'showInPublish', duration: 'duration', attendees: 'attendees' }

export interface SessionTableData extends BaseTableData {
  [sessionColumns.sessionInfo]: SessionInfo
  [sessionColumns.duration]: TableText
  [sessionColumns.attendees]: TableText
  [sessionColumns.sponsors]: TableText
  [sessionColumns.stagingNotes]: TableText
  [sessionColumns.publicLinks]: TableText
  [sessionColumns.briefNotes]: TableText
  [sessionColumns.flagged]: TableFlag
  [sessionColumns.name]: TableText
  [sessionColumns.assets]: TableLights
  [sessionColumns.performerAssets]: TableLights
  [sessionColumns.sponsorAssets]: TableLights
  [sessionColumns.briefed]: TableLights
  [sessionColumns.stagingRequests]: TableLights
  [sessionColumns.sessionUrl]: TableLights
  [sessionColumns.dateTime]: TableDate
  [sessionColumns.performerStatus]: { [performerId: string]: TableLights }
  [sessionColumns.confirmed]: TableLights
  [sessionColumns.summary]: TableLights
  [sessionColumns.performers]: TableText
  [sessionColumns.description]: TableText
  [sessionColumns.programName]: TableText
  [sessionColumns.sessionLabels]: TableLabel[]
  [sessionColumns.programLabels]: TableLabel[]
  [sessionColumns.showInPublish]: TableLights
}

interface programColumnIds { name, venueLocation, venueAddress, timeZone, assets, expectedNumbers, setup, setupNotes, files, labels, program }
export const programColumns: AllSameKeyValuesEnforcer<programColumnIds> = { name: 'name', venueLocation: 'venueLocation', venueAddress: 'venueAddress',
  timeZone: 'timeZone', assets: 'assets', expectedNumbers: 'expectedNumbers', setup: 'setup', setupNotes: 'setupNotes', files: 'files', 
  labels: 'labels', program: 'program' }

export interface ProgramTableData extends BaseTableData {
  [programColumns.program]: Program
  [programColumns.venueAddress]: TableText
  [programColumns.venueLocation]: TableText
  [programColumns.timeZone]: TableText
  [programColumns.expectedNumbers]: TableText
  [programColumns.name]: TableText
  [programColumns.assets]: TableLights
  [programColumns.setup]: TableText
  [programColumns.setupNotes]: TableText
  [programColumns.files]: TableText
  [programColumns.labels]: TableLabel[]
}


interface ExhibitorStandColumnIds { standNumber, standSize, standNotes, program, standFiles, standAssets, exhibitor, standRequests }

export const exhibitorStandColumns: AllSameKeyValuesEnforcer<ExhibitorStandColumnIds> = { standNumber:'standNumber', standSize:'standSize', standNotes:'standNotes', program:'program', standFiles:'standFiles', standAssets:'standAssets', exhibitor: 'exhibitor', standRequests: 'standRequests' }

export interface ExhibitorStandsTableData extends BaseTableData {
  exhibitorStand: ExhibitorStand
  [exhibitorStandColumns.exhibitor]: TableText
  [exhibitorStandColumns.standNumber]: TableText
  [exhibitorStandColumns.standSize]: TableRank
  [exhibitorStandColumns.standNotes]: TableText
  [exhibitorStandColumns.program]: TableText
  [exhibitorStandColumns.standFiles]: TableLights
  [exhibitorStandColumns.standAssets]: TableLights
  [exhibitorStandColumns.standRequests]: TableLights
}

interface SponsorSessionColumnIds { title, sponsorSummary, time, description, sponsorCount, sessionLabels, programLabels, programName, sponsorStatus, sessionInfo }

export const sponsorSessionColumns: AllSameKeyValuesEnforcer<SponsorSessionColumnIds> = { title: 'title', sponsorCount: 'sponsorCount', sponsorSummary: 'sponsorSummary', time: 'time', description: 'description', sessionLabels: 'sessionLabels', programLabels: 'programLabels', programName: 'programName', sessionInfo: 'sessionInfo', sponsorStatus: 'sponsorStatus', }

export interface SponsorSessionTableData extends BaseTableData {
  [sponsorSessionColumns.sessionInfo]: SessionInfo
  [sponsorSessionColumns.title]: TableText
  [sponsorSessionColumns.sponsorSummary]: TableLights
  [sponsorSessionColumns.time]: TableDate
  [sponsorSessionColumns.sponsorStatus]: { [sponsorId: string]: TableLights }
  [sponsorSessionColumns.description]: TableText
  [sponsorSessionColumns.sponsorCount]: TableText
  [sponsorSessionColumns.sessionLabels]: TableLabel[]
  [sponsorSessionColumns.programName]: TableText
  [sponsorSessionColumns.programLabels]: TableLabel[]
}